<div id="why">
    <div class="container pt-5" data-scroll>
        <div class="row">
            <div class="col-12 text-center">
                <h2 class="home-title text-center">WHAT MAKES IIMT UNIQUE?</h2>
                <p>We equip our students with the knowledge and skills needed to excel in the ever-evolving professional landscape.</p>
            </div>
            <div class="col-12 col-lg-6 mb-4">
                <div class="box box1">
                    <img src="/assets/img/why/3.jpeg" alt="" class="img-fluid rounded-3">
                    <div class="overlay2 p-4 text-white">
                        <h5 class="mb-0">Legacy of</h5>
                        <h3> Visionary Education</h3>
                        <p class="d-none d-md-block d-lg-none d-xl-block">IIMT traces its roots back to 1938,with its rich
                            heritage and strong foundation.</p>
                    </div>
                </div>
                <div class="mt-4 box box2">
                    <img src="/assets/img/why/2.JPG" alt="" class="img-fluid rounded-3">
                    <div class="overlay1 p-4 text-white">
                        <h5 class="mb-0">Diverse and Future</h5>
                        <h3> Oriented Programs</h3>
                        <p class="d-none d-md-block d-lg-none d-xl-block">At IIMT, we believe in staying ahead of
                            the curve by constantly striving to upgrade our
                            curriculum.</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="box box3">
                    <img src="/assets/img/why/1.jpeg" alt="" class="img-fluid rounded-3">
                    <div class="overlay3 p-4 text-white">
                        <h5 class="mb-0">State-of-the-Art  Facilities</h5>
                        <h3> and Holistic Development</h3>
                        <p class="d-none d-md-block d-lg-none d-xl-block">We prioritize the overall
                            development of our students, and our students
                            have consistently brought accolades to the college.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>